<template lang="html">
  <div class="main">
    <div class="header">
      <div class="logo" style="margin-top: 10px; display: flex; align-items: center;">
        <img src="../assets/h-logo.8552f672.png" style="width: 50px; height: 50px; display: inline-block;">
        <span style="font-size: 30px; margin-left: 10px; display: inline-block;">药到家官网</span>
      </div>
      <div v-if="!isLoggedIn" class="login" @click="login">
        注册/登录
      </div>
      <div v-else class="user-info">
        <span class="username">{{ currentUser }}</span>
        <a-dropdown>
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item key="0" @click="logout">
              退出登录
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <div class="menu-container">
      <div class="menu-item product-center" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
        <router-link :to="{ name: 'home' }" exact>产品中心</router-link>
        <transition name="dropdown">
          <div class="dropdown-menu" v-show="showDropdown">
            <router-link :to="{ name: 'home', query: { category: 'cold' } }" class="dropdown-item" active-class="active">感冒用药</router-link>
            <router-link :to="{ name: 'home', query: { category: 'stomach' } }" class="dropdown-item" active-class="active">肠胃用药</router-link>
            <router-link :to="{ name: 'home', query: { category: 'pediatric' } }" class="dropdown-item" active-class="active">儿科用药</router-link>
            <router-link :to="{ name: 'home', query: { category: 'gynecological' } }" class="dropdown-item" active-class="active">妇科药品</router-link>
            <router-link :to="{ name: 'home', query: { category: 'medical' } }" class="dropdown-item" active-class="active">医疗器械</router-link>
          </div>
        </transition>
      </div>
      <router-link :to="{ name: 'infoListView' }" class="menu-item" exact>信息发布</router-link>
      <router-link :to="{ name: 'aboutUs' }" class="menu-item" exact>关于我们</router-link>
    </div>
    <div class="mask" v-show="isMask"></div>
    <Login v-show="isShow" @closeLogin="closeLogin" @fnRegister="fnRegister" style="position:fixed;z-index:110;" />
    <Register v-show="Register" @goLogin="goLogin" style="position:fixed;z-index:110;" />

    <!-- 返回顶部 -->
    <a-back-top />

  </div>
</template>

<script>
import Login from './login.vue'
import Register from './register'
import eventBus from '@/utils/eventBus'

export default {
  components: {
    Login,
    Register,
  },
  data() {
    return {
      isShow: false,
      isMask: false,
      Register: false,
      isLoggedIn: false,
      currentUser: '',
      showDropdown: false
    }
  },
  created() {
    // 检查登录状态
    this.checkLoginStatus();
  },
  methods: {
    checkLoginStatus() {
      // 检查是否是管理员登录
      if (localStorage.getItem('isAdmin') === 'true') {
        this.isLoggedIn = true;
        this.currentUser = '管理员';
        return;
      }

      // 检查普通用户登录状态
      const currentUser = localStorage.getItem('currentUser');
      if (currentUser) {
        this.isLoggedIn = true;
        this.currentUser = currentUser;
      }
    },
    login() {
      this.isShow = true;
      this.isMask = true;
    },
    fnRegister(data) {
      if (data == false) {
        this.isShow = false;
        this.Register = true;
      }
    },
    closeLogin(data) {
      if (data == false) {
        this.isShow = false;
        this.isMask = false;
        // 登录成功后更新状态
        this.checkLoginStatus();
      }
    },
    goLogin(data) {
      if (data == false) {
        this.Register = false;
        this.isShow = true;
      }
    },
    logout() {
      // 清除登录状态
      localStorage.removeItem('currentUser');
      localStorage.removeItem('isAdmin');
      this.isLoggedIn = false;
      this.currentUser = '';

      // 触发登录状态变化事件
      eventBus.$emit('login-status-changed');

      this.$notification['success']({
        message: '提示',
        description: '已成功退出登录',
        duration: 2
      });
    }
  }
}
</script>

<style lang="scss" >
.main {
  width: 100%;
  background: #FFF;

  .header {
    width: 1220px;
    height: 92px;
    margin: 0 auto;

    .logo {
      width: 220px;
      padding-top: 10px;
      float: left;

      img {
        display: block;
        width: 211px;
        height: auto;
        text-align: left;
      }
    }

    .login {
      width: 140px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 20px;
      background: #1890ff;
      color: #fff;
      border-radius: 25px;
      float: right;
      cursor: pointer;
      margin-top: 25px;
    }

    .user-info {
      float: right;
      margin-top: 25px;
      display: flex;
      align-items: center;

      .username {
        font-size: 16px;
        color: #1890ff;
        margin-right: 8px;
      }

      .ant-dropdown-link {
        color: #1890ff;
        cursor: pointer;
      }
    }
  }

  .menu-container {
    width: 1220px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    background: #FDFDFF;
    position: relative;
  }

  .menu-item {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    text-decoration: none;
    color: rgba(0, 0, 0, 0.65);
    font-size: 16px;
    position: relative;

    &:hover {
      color: #1890ff;
    }

    &.product-center {
      cursor: pointer;
    }

    &.router-link-active {
      color: #1890ff;
      font-weight: 500;
    }
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    min-width: 110px;
    z-index: 1000;
    transform-origin: top center;
  }

  .dropdown-item {
    display: block;
    padding: 8px 16px;
    color: rgba(0, 0, 0, 0.65);
    text-decoration: none;
    white-space: nowrap;
    font-size: 14px;
    transition: all 0.3s ease;

    &:hover {
      background: #e6f7ff;
      color: #1890ff;
    }

    &.active {
      color: #1890ff;
      background: #e6f7ff;
    }
  }

  .mask {
    width: 100% !important;
    height: 100% !important;
    position: fixed;
    top: 0;
    background: rgba(000, 000, 000, .6);
    z-index: 100;
  }

  // 添加过渡动画
  .dropdown-enter-active,
  .dropdown-leave-active {
    transition: all 0.3s ease;
  }

  .dropdown-enter,
  .dropdown-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }
}
</style>